import { GetterTree } from "vuex";

import { IRootState } from "../types";
import { IIdentityState } from "./types";

export const getters: GetterTree<IIdentityState, IRootState> = {
  isAuthenticated: (state: IIdentityState) => state.isAuthenticated,
};
